export default __webpack_public_path__ + "static/media/hackathon-level-4.12343af7.svg";